import { useState } from 'react'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import styles from './EditTASettingsDialog.module.scss'

const EditTASettingsDialog = ({
  reviewTripAdvisorMinStars,
  handleClose,
  handleConfirm
}) => {
  const [minRating, setMinRating] = useState(reviewTripAdvisorMinStars)

  return (
    <ConfirmationDialog
      title="Review settings"
      theme="blacklist"
      positiveMessage="Save changes"
      onClose={handleClose}
      onConfirm={() =>
        handleConfirm({
          reviewTripAdvisorMinStars: minRating
        })
      }
      isButtonDisabled={!(minRating <= 5 && minRating >= 0.5 && minRating % 0.5 === 0)}
    >
      <div className={styles.container}>
        <TextInput
          label=" Min. rating for TA review"
          value={minRating}
          type="number"
          step={0.5}
          max={5}
          min={0.5}
          onChange={e => setMinRating(e.target.value)}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default EditTASettingsDialog
